import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        tooltip: {
            "display": false,
            'content': "",
            'position': "",
            "elementTarget": null,
        },
        contextMenu: {
            "display": false,
            "event":null,
            "options" : {},
            "id" : null,
            "class" : null
        },
        storification: {
            link: null
        }
   
    },
    mutations: {

        /// Tooltip ///

        updateTooltipContent(state, newContent) {
            state.tooltip.content = newContent;
        },
        updateTooltipDisplay(state, newDisplay) {
            state.tooltip.display = newDisplay;
        },
        updateTooltipPosition(state, newPosition) {
            state.tooltip.position = newPosition;
        },
        updateTooltipElementTarget(state, newElementTarget) {
            state.tooltip.elementTarget = newElementTarget;
        },  

        /// Context Menu ///
        
        updateContextMenuDisplay(state, newDisplay) {
            state.contextMenu.display = newDisplay;
        },
        updateContextMenuComponent(state, newComponent) {
            state.contextMenu.component = newComponent;
        },
        updateContextMenuOptions(state, newOptions) {
            state.contextMenu.options = newOptions;
        }, 
        updateContextMenuId(state, newId) {
            state.contextMenu.id = newId;
        }, 
        updateContextMenuEvent(state, newEvent) {
            state.contextMenu.event = newEvent;
        }, 
        updateContextMenuClass(state, newClass) {
            state.contextMenu.class = newClass;
        }, 

        /// Storification ///

        updateStorification(state, data) {
            console.log(data);
            state.storification = data;
        },

        updateStorificationLink(state, newLink) {
            if(!state.storification) state.storification = {}
            state.storification.link = newLink && state && state.storification ? {...state.storification.link, ...newLink} : null;
        }
    },
    actions: {
        resetStorification() {
            this.commit('updateStorificationLink', null);
        }

    },
    getters: {

        /// Tooltip ///

        tooltipDisplay(state) {
            return state.tooltip.display;
        },
        tooltipContent(state) {
            return state.tooltip.content;
        },
        tooltipPosition(state) {
            return state.tooltip.position;
        },
        tooltipElementTarget(state) {
            return state.tooltip.elementTarget;
        },

        /// Context Menu ///
        contextMenuDisplay(state) {
            return state.contextMenu.display;
        },
        contextMenuOptions(state) {
            return state.contextMenu.options;
        },

        contextMenuId(state) {
            return state.contextMenu.id;
        },

        contextMenuEvent(state) {
            return state.contextMenu.event;
        },
        contextMenuClass(state) {
            return state.contextMenu.class;
        },

        /// Storification ///
        storification(state) { 
            return state.storification;
        },

        storificationLink(state) {
            if (!state.storification) return null;
            return state.storification.link;
        }


    }
});